export default {
  buttons: {
    back: 'Indietro',
  },
};
